module.exports = __webpack_public_path__ + "img/09-峨眉山.0c493194.jpg";